/**
 * Where the public site hands a visitor over to the application.
 *
 * The app origin is the only origin registered as an Entra redirect URI, so
 * this site never starts authentication itself — every Sign In/Sign Up control
 * is a plain link to `/login` over there. That is what keeps MSAL out of this
 * bundle entirely.
 *
 * With the variable unset (local dev, e2e) the links stay relative, so the
 * markup is still exercised without a second origin running.
 */

/** Marks which side of the split a sign-in handoff came from. */
export type AuthIntent = "signIn" | "signUp";

const INTENT_PARAM = "intent";

const INTENT_VALUES: Record<AuthIntent, string> = {
  signIn: "signin",
  signUp: "signup",
};

export function appOrigin(): string {
  return (import.meta.env.VITE_APP_ORIGIN ?? "").trim().replace(/\/+$/, "");
}

export function appEntryUrl(intent: AuthIntent): string {
  return `${appOrigin()}/login?${INTENT_PARAM}=${INTENT_VALUES[intent]}`;
}
